import { AlkLogger } from '@alk/core';
import { IMouseTrackingService, IPosition } from './mouse-tracking.interface';
import { injectable } from 'inversify';
import { Observable, Subject } from 'rxjs';

@injectable()
export class MouseTrackingMock implements IMouseTrackingService{
    start(): void {
        AlkLogger.info('[MouseTrackingMock] start()');
    }

    stop(): void {
        AlkLogger.info('[MouseTrackingMock] stop()');
    }

    move(): void {
        AlkLogger.info('[MouseTrackingMock] move()');
    }

    isTracked(): boolean {
        AlkLogger.info('[MouseTrackingMock] isTracked()');

        return false;
    }

    asObservable(): Observable<IPosition> {
        AlkLogger.info('[MouseTrackingMock] asObservable()');

        return (new Subject<IPosition>()).asObservable();
    }
}
